import { DEFAULT_REGION, REGION_ALLOWED_PATHS, REGION_KEY } from 'shared/components/RegionSwitcher/constants';
import { resolveRegion } from 'shared/components/RegionSwitcher/regionSessionStorage';
import { sidebarItems } from 'components/molecules/LeftSidebar/constants';
var normalizePath = function normalizePath(path) {
    return path.replace(/\/$/, '');
};
export var getRegionFromSearch = function getRegionFromSearch(search) {
    return resolveRegion(new URLSearchParams(search).get(REGION_KEY));
};
export var isPathAllowedForRegion = function isPathAllowedForRegion(pathname) {
    var region = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_REGION;
    var allowedPaths = REGION_ALLOWED_PATHS[region];
    if (!allowedPaths) {
        return true;
    }
    var currentPath = normalizePath(pathname);
    return allowedPaths.some(function (allowedPath) {
        var allowed = normalizePath(allowedPath);
        return currentPath === allowed || currentPath.startsWith("".concat(allowed, "/"));
    });
};
export var getRedirectPathItemsForRegion = function getRedirectPathItemsForRegion(region) {
    return sidebarItems.filter(function (item) {
        var _item$url;
        return isPathAllowedForRegion((_item$url = item.url) !== null && _item$url !== void 0 ? _item$url : '', region);
    });
};
export var getPathWithRegion = function getPathWithRegion(path, region) {
    var url = new URL(path, window.location.origin);
    url.searchParams.set(REGION_KEY, region);
    return "".concat(url.pathname).concat(url.search);
};
